(function ($) {
    function cl(log) {
        console.log(log)
    }

    const CLASSES = {
        cartItem: '.line-item',
        cartItemMeta: '.cart__item-title',
        cartItemTitle: '.cart__item-title > a',
        cartItemPrice: '.cart__item-price',
        cartLineItemProperty: '.line-item__property',
    }

    var neonCart = {
        getCart() {
            return $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function (res) {
                    console.log('success', res);
                },
                error: function (x, j, r) {
                    console.log(x)
                    console.log(j)
                    console.log(r)
                }
            });
        },
        updatePrices: function () {
            const lineItems = $(CLASSES.cartItem);
            lineItems.each(function (i, v) {
                var item = $(v);
                var meta = item.find(CLASSES.cartItemMeta);
                var title = item.find(CLASSES.cartItemTitle)[0];

                if (title.text.includes('Create Your Own Neon Sign')) {
                    const currency = theme.settings.moneyFormat.split('{')[0];
                    const properties = item.find('.line-item__property').toArray();
                    const addedPrice = properties.find(prop => prop.innerText.trim().includes('add_price:'))
                    if (addedPrice) {
                        const price = parseFloat(addedPrice.innerText.split(':')[1]);
                        const priceEl = item.find('.bcpo-cart-item-line-price');
                        const thisPrice = parseFloat(item.text().split(currency)[1]);
                        const newPrice = currency + '' + (price + thisPrice).toFixed(2);
                        priceEl.text(newPrice);
                        // Get total price element and update it.
                        const totalPrice = $('.bcpo-cart-original-total');
                        const totalPriceText = totalPrice.text().split(currency)[1];
                        const newTotalPrice = currency + '' + (price + parseFloat(totalPriceText)).toFixed(2);
                       totalPrice.text(newTotalPrice);
                    }
                }

                if ((title.text.includes('Item Personlisation') || title.text.includes('Item Personlization')) && !item.data('uuid')) {


                }


            });
        },
        hidePriceRef: function (meta) {
            meta.find(CLASSES.cartLineItemProperty).each(function (i, v) {
                let lineItem;
                let value;
                const item = v;

                const propKey = item.innerText
                if (propKey.includes('pricing_ref') || propKey.includes('add_price')) {
                    item.style.display = 'none';
                    value = item.innerText.split(':');
                    if(propKey.includes('pricing_ref')){
                        lineItem = meta.closest(CLASSES.cartItem);
                        lineItem[0].setAttribute('data-ref', value[1].trim());
                    }
                }

                // Hide the image property and update the image.
                if (item.innerText.includes('Image')) {
                    item.style.display = 'none';
                    value = item.innerText.split(':');
                    lineItem = meta.closest(CLASSES.cartItem);
                    const image = lineItem.find('.cart__image img')[0];
                    const imageLink = lineItem.find('.cart__image a')[0];
                    imageLink.href = '/pages/custom-sign'
                    image.removeAttribute('data-srcset')
                    setTimeout(() => {
                        image.srcset = ''
                        image.setAttribute('src', value[1] + ':' + value[2]);
                    }, 500)
                }

            });
        },
        hidePersonal: function () {
            const lineItems = $(CLASSES.cartItem);
            lineItems.each(function (i, v) {

                const item = $(v);
                const meta = item.find(CLASSES.cartItemMeta);
                const title = item.find(CLASSES.cartItemTitle)[0];
                neonCart.hidePriceRef(meta);

                if (title.text.includes('Create Your Own')) {
                    title.href = '/pages/custom-sign';
                }

                if ((title.text.includes('Item Personalisation') || title.text.includes('Item Personlization')) && !item.data('uuid')) {
                    item.find('.quantity-selector__button').remove()
                    item.find('.quantity-selector input').attr('disabled', true)
                    item[0].style.pointerEvents = 'none'
                    item.find('.quantity-selector').hide()
                    item.find('.line-item__quantity-remove').remove()
                    item.hide()
                }

            });
        },
        removePersonal: function (lineItems) {
            $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: {
                    updates: lineItems
                },
                async: false,
                dataType: 'json',
                success: function () {
                    window.location = '/cart'
                },
                error: function () {
                    console.log('Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
                }

            });
            //32431348285536 // Sign
            //32432033169504 //personalise
        },
        createCheckout: function () {
            $('[name=checkout]').on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                const overlay = $('#overlay');
                //overlay.show();
                const cartPromise = neonCart.getCart();
                cartPromise.then(cart => {
                    const hasCustom = cart.items.findIndex(item => item.title === 'Create Your Own Neon Sign')
                    if (hasCustom !== -1) {
                        const discountInput = document.querySelector('#discount--input')
                        const discountValue = discountInput && discountInput.value ? discountInput.value : ''
                        return $.ajax({
                            type: 'POST',
                            url: '/apps/api/order',
                            headers:{
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            data: {
                                cart: cart,
                                discount: discountValue
                            },
                            success: function (res) {
                                console.log('success', res);
                                //overlay.hide();
                                if (!res.errors) {
                                    const invoiceUrl = res && res.body && res.body.draft_order ? res.body.draft_order.invoice_url : ''
                                    if (invoiceUrl) {
                                        window.location.href = invoiceUrl
                                    }
                                } else {
                                    $('.cart__page-col').append('<div class="neon-error">' +
                                        '<span style="color:darkred;">' + res.body + '</span>' +
                                        '</div>')
                                }
                            },
                            error: function (x, j, r) {
                                console.log(x)
                                console.log(j)
                                console.log(r)
                                console.log('Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
                            }
                        })
                    }

                    // Submit the button event as normal but without triggering itself
                    $(this).unbind('click').click();

                })

            })
        },
        removeOrphanedPriceRefs: function () {

            const lineItems = $(CLASSES.cartItem);
            let personalisationToRemove = {}
            lineItems.each(function (idx, v) {
                const item = $(v)
                const itemRef = item.data('ref')
                if (itemRef) {
                    const itemsWithRef = lineItems.filter((idx, item) => item.dataset['ref'] === itemRef)
                    if (itemsWithRef.length === 1) {
                        personalisationToRemove[itemsWithRef[0].dataset['key']] = 0
                    }
                }
            })
            if (Object.keys(personalisationToRemove).length > 0) {
                neonCart.removePersonal(personalisationToRemove);
            }

        },
        init: function () {
            neonCart.hidePersonal()
            neonCart.updatePrices()
            neonCart.createCheckout()
            //neonCart.removeOrphanedPriceRefs()

            $('.line-item__quantity-remove').on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();

                const that = $(this);
                const line_items = {}

                const lineID = that.closest(CLASSES.cartItem).data('line-id');
                line_items[lineID] = 0;
                const properties = that.closest(CLASSES.cartItem).find(CLASSES.cartLineItemProperty);
                let ref = ''

                properties.each(function (i, v) {
                    var item = $(v);
                    var textContent = item[0].textContent;
                    if (textContent.includes('pricing_ref')) {
                        var split = textContent.split(':');
                        ref = split[1];
                    }
                });

                /*
              * Only remove a hidden lineitem if there is matching ref.
              */
                if (ref) {
                    const lineItems = $(CLASSES.cartItem);
                    lineItems.each(function (i, v) {
                        const item = $(v);
                        const meta = item.find(CLASSES.cartItemMeta);
                        const title = item.find(CLASSES.cartItemTitle)[0];
                        if ((title.text.includes('Item Personalisation') || title.text.includes('Item Personalization'))) {
                            const properties = item.find('.line-item__property');
                            properties.each(function (i, v) {

                                var subItem = $(v);
                                var textContent = subItem[0].textContent;

                                if (textContent.includes('pricing_ref')) {

                                    cl('found another ref');
                                    line_items[item.data('line-id')] = 0

                                }

                            });
                        }
                    });
                }

                //Remove all the line items which have been found or clicked on.
                neonCart.removePersonal(line_items);
            });
        }

    }
    /*
     * Initialise the cart tool.
     * */
    neonCart.init();
    window.onload = function () {
        console.log('Cart Tool Loaded');
    };

})(jQuery);
